// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6b4536ea] .el-dialog{width:552px}.dialog-body[data-v-6b4536ea]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;padding:10px 0;color:#080707}.dialog-body .icon[data-v-6b4536ea]{display:inline-block;margin-right:10px}", ""]);
// Exports
module.exports = exports;
